import { jsx as e, jsxs as d } from "react/jsx-runtime";
import i from "./quote-block.module.less.js";
import { getImageLoading as l } from "../../../helpers/image-helper.js";
import "dayjs";
import { m as c } from "motion/react";
import { Heading as m } from "../../elements/heading/heading.js";
import { useAnimateFadeIn as p } from "../../../animation/animation.js";
const h = ({ quote: n, name: r, workTitle: a, image: s, blockIndex: t }) => {
  const o = p({ whileInView: !0, easing: "easeInOut" }, { blockIndex: t });
  return /* @__PURE__ */ d("div", { className: i.quoteWrapper, children: [
    /* @__PURE__ */ d(c.div, { ...o, className: i.textWrapper, children: [
      n && /* @__PURE__ */ e(
        m,
        {
          index: t,
          semanticType: "h3",
          visualType: "h4",
          className: [i.quote, "heading-max-width"].join(" "),
          children: `"${n}"`
        }
      ),
      (r || a) && /* @__PURE__ */ e("div", { className: i.nameAndTitle, children: (r || a) && /* @__PURE__ */ e("p", { className: [i.workTitle, "eyebrow"].join(" "), children: [r, a].join(", ") }) })
    ] }),
    s && /* @__PURE__ */ e(c.div, { ...o, children: /* @__PURE__ */ e("div", { className: i.imageWrapper, children: /* @__PURE__ */ e("img", { className: i.image, src: s.url, alt: s.alt, loading: l(t) }) }) })
  ] });
}, y = ({ quotes: n = [], index: r }) => /* @__PURE__ */ e("section", { className: i.wrapper, children: /* @__PURE__ */ e("div", { className: [i.contentWrapper, "max-width centered padded-sides"].join(" "), children: /* @__PURE__ */ e("ul", { className: i.blockList, children: n.map((a) => /* @__PURE__ */ e("li", { children: /* @__PURE__ */ e(h, { blockIndex: r, ...a }) }, a.quote)) }) }) });
export {
  y as QuoteBlock,
  y as default
};
